import { render, staticRenderFns } from "./health-chart.vue?vue&type=template&id=2baa9d76&scoped=true"
import script from "./health-chart.vue?vue&type=script&lang=js"
export * from "./health-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa9d76",
  null
  
)

export default component.exports